export const INVALID_CREDENTIALS = 'Invalid email or password';
export const USER_EMAIL_ALREADY_EXISTS = 'A user with this email address already exists';
export const USER_ACCESS_DISABLED = 'User access disabled';
